export const SaveChangesIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="none"
    viewBox="0 0 20 20"
  >
    <path
      stroke="#0A0D14"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M5 1v3.4c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C5.76 6 6.04 6 6.6 6h6.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C15 5.24 15 4.96 15 4.4V2m0 17v-6.4c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C14.24 11 13.96 11 13.4 11H6.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C5 11.76 5 12.04 5 12.6V19M19 7.325V14.2c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C16.72 19 15.88 19 14.2 19H5.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C1 16.72 1 15.88 1 14.2V5.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C3.28 1 4.12 1 5.8 1h6.875c.489 0 .733 0 .963.055.204.05.4.13.579.24.201.123.374.296.72.642l3.126 3.126c.346.346.519.519.642.72q.165.27.24.579c.055.23.055.474.055.963"
    />
  </svg>
);
